/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Payment_Method_Change_Shipping_FeeInputs */

const vi_error_payment_method_change_shipping_fee = /** @type {(inputs: Error_Payment_Method_Change_Shipping_FeeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khoản chuyển khoản này gồm cả tiền ship khách trả trước của đơn quà, mà ship trả trước chỉ được tính khi là chuyển khoản, nên chưa cho đổi. Hãy báo quản trị nếu cần sửa.`)
};

/**

* @param {Error_Payment_Method_Change_Shipping_FeeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_payment_method_change_shipping_fee = /** @type {((inputs?: Error_Payment_Method_Change_Shipping_FeeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Payment_Method_Change_Shipping_FeeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_payment_method_change_shipping_fee(inputs)
});